import { apiFetch } from "../api.js";
import type {
  Create529ContributionInput,
  CreateDripInput,
  CreateHsaCashflowInput,
  CreateSaleInput,
  SaleResult,
} from "./types.js";

/**
 * Transactions API module — Phase 3 Session 3 launched POST; Phase 5
 * Session 5 added GET (filtered by transaction_type + date range) plus
 * the 529 / HSA cashflow branches on POST.
 */

export interface TransactionsListResponse {
  transactions: Record<string, unknown>[];
  count: number;
}

export function listTransactions(
  accountId: string,
  opts?: {
    transaction_type?: string | string[];
    from?: string;
    to?: string;
  },
): Promise<TransactionsListResponse> {
  const params = new URLSearchParams();
  if (opts?.transaction_type) {
    const t = Array.isArray(opts.transaction_type)
      ? opts.transaction_type.join(",")
      : opts.transaction_type;
    params.set("transaction_type", t);
  }
  if (opts?.from) params.set("from", opts.from);
  if (opts?.to) params.set("to", opts.to);
  const qs = params.toString() ? `?${params.toString()}` : "";
  return apiFetch<TransactionsListResponse>(
    `/v1/accounts/${accountId}/transactions${qs}`,
  );
}

export function createSale(
  accountId: string,
  input: CreateSaleInput,
): Promise<SaleResult> {
  return apiFetch<SaleResult>(`/v1/accounts/${accountId}/transactions`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function createDrip(
  accountId: string,
  input: CreateDripInput,
): Promise<{ transaction: Record<string, unknown>; lot: Record<string, unknown> }> {
  return apiFetch(`/v1/accounts/${accountId}/transactions`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function create529Contribution(
  accountId: string,
  input: Create529ContributionInput,
): Promise<{ transaction: Record<string, unknown> }> {
  return apiFetch(`/v1/accounts/${accountId}/transactions`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function createHsaCashflow(
  accountId: string,
  input: CreateHsaCashflowInput,
): Promise<{ transaction: Record<string, unknown> }> {
  return apiFetch(`/v1/accounts/${accountId}/transactions`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}
